<script setup>
const props = defineProps({
    title: {
        type: String,
        required: false,
    },
    description: {
        type: String,
        required: false,
    },
    label: {
        type: String,
        default: 'Share',
    },
    link: {
        type: String,
        required: false,
    },
    copyToClipboard: {
        type: Boolean,
        default: false,
    },
});

const showToast = ref(false);

const shareTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(props.title)}&url=${props.link ? props.link : window.location.href}`;
    window.open(url, '_blank');
};

const shareFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${props.link ? props.link : window.location.href}`;
    window.open(url, '_blank');
};

const shareLinkedIn = () => {
    const url = `https://www.linkedin.com/shareArticle?mini=true&url=${props.link ? props.link : window.location.href
        }&title=${props.title}${props.description ? '&summary=' + props.description : ''}`;
    window.open(url, '_blank');
};

const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(props.link ? props.link : window.location.href).then(() => {
        showToast.value = true;
        setTimeout(() => {
            showToast.value = false;
        }, 2000);
    });
};
</script>

<template>
    <div class="share">
        <p class="fs-12">{{ label }}</p>
        <ul class="social-links links">
            <li>
                <button @click="shareLinkedIn" aria-label="Share on LinkedIn">
                    <MessSvg type="linkedIn" />
                    <span class="sr-only">(opens in a new tab)</span>
                </button>
            </li>
            <li>
                <button @click="shareFacebook" aria-label="Share on Facebook">
                    <MessSvg type="facebook" />
                    <span class="sr-only">(opens in a new tab)</span>
                </button>
            </li>
            <li>
                <button @click="shareTwitter" aria-label="Share on Twitter">
                    <MessSvg type="twitter" />
                    <span class="sr-only">(opens in a new tab)</span>
                </button>
            </li>
            <li v-if="copyToClipboard" class="copy-link">
                <button @click="copyLinkToClipboard" aria-label="Copy link to clipboard">
                    <MessSvg type="clipboard" />
                </button>
                <div v-if="showToast" class="toast">Link copied to clipboard!</div>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
.share {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    font-weight: 400;
    text-transform: uppercase;
    color: var(--teal-gray);

    p {
        margin: 0;
        margin-right: 0.25rem;
    }

    .links {
        display: flex;
        gap: 1rem;

        li {
            cursor: pointer;
            color: var(--teal-gray);

            svg {
                transition: 100ms ease;
                width: 2.25rem;
                height: 2.25rem;
            }

            &:hover {
                color: var(--cream);
                svg path {
                    fill: var(--cream);
                }
                svg circle {
                    fill: var(--teal);
                    stroke: var(--teal);
                }
            }
        }

        .copy-link {
            position: relative;

            .toast {
                position: absolute;
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%);
                background-color: var(--orange-dark);
                color: white;
                padding: 0.5rem 1rem;
                font-size: 14px;
                font-weight: normal;
                text-transform: none;
                opacity: 0;
                animation: fadeInOut 2s ease-in-out;
                white-space: nowrap;
                margin-bottom: 8px;
            }
        }
    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
            transform: translate(-50%, 10px);
        }

        10% {
            opacity: 1;
            transform: translate(-50%, 0);
        }

        90% {
            opacity: 1;
            transform: translate(-50%, 0);
        }

        100% {
            opacity: 0;
            transform: translate(-50%, 10px);
        }
    }
}
</style>
